/**
 * Internal dependencies
 */
import { isReturningVisitor } from '../index';
import type { Attributes } from '../../../../../../packages/segmentation-rule-library/rules/visitor-type/types';

export const type = 'nab/visitor-type';

export function validate( attributes: Attributes ): boolean {
	const { condition } = attributes;

	switch ( condition ) {
		case 'is-new-visitor':
			return ! isReturningVisitor();
		case 'is-returning-visitor':
			return isReturningVisitor();
	}
}
